export type SdAppRole =
  | "ServiceDesk_Admin"
  | "ServiceDesk_Agent"
  | "ServiceDesk_SuperAgent"
  | "ServiceDesk_External_Agent"
  | "ServiceDesk_External_Customer"
  | "ServiceDesk_User";

/** Service Desk app is mounted at /sd — use for all in-app links */
export const SD_BASE = "/sd";

export function sd(path: string): string {
  if (!path || path === "/") {
    return SD_BASE;
  }
  return `${SD_BASE}${path.startsWith("/") ? path : `/${path}`}`;
}

/** Email reset link must land on `/sd/forgot-password-reset/{token}`, not PTS/A1 `/forgot-password-reset/`. */
export function getSdForgotPasswordResetUrl(token?: string): string {
  const origin =
    typeof window !== "undefined"
      ? window.location.origin.replace(/\/$/, "")
      : "";
  if (token) {
    return `${origin}${sd(`forgot-password-reset/${token}`)}`;
  }
  return `${origin}${sd("forgot-password-reset")}/`;
}

/** Role ke liye default home path (unauthorized / wrong section) */
export function getDefaultSdPath(role: SdAppRole | null): string {
  if (role === "ServiceDesk_Admin") return `${SD_BASE}/admin`;
  if (
    role === "ServiceDesk_External_Agent" ||
    role === "ServiceDesk_External_Customer"
  ) {
    return `${SD_BASE}/tickets/my-tickets`;
  }
  if (role === "ServiceDesk_Agent") {
    return `${SD_BASE}/tickets/project-status`;
  }
  if (role === "ServiceDesk_SuperAgent") return `${SD_BASE}/tickets/project-status`;
  if (role === "ServiceDesk_User") return `${SD_BASE}/my-portal`;
  return `${SD_BASE}/login`;
}

/** Agent `/sd/tickets/:queue` → admin panel equivalent (Admin must not use Stream UI). */
export function mapTicketsQueueToAdminPath(queue?: string): string {
  switch (queue) {
    case "kanban":
      return sd("admin/kanban");
    case "report":
      return sd("admin/report");
    case "project-status":
      return sd("admin/project-status");
    default:
      return sd("admin/tickets");
  }
}
